// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1znxn","header":"ReportDetails_header__2oT_Y","title":"ReportDetails_title__2IQvO","left":"ReportDetails_left__36DpB"};